import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setPhoneNumber } from "../../modules/form";
import styled from "styled-components";
import { Title } from "../common/Title";
import HandlePhoneNumber from "./HandlePhoneNumber";
import CommonContainer from "../common/CommonContainer";
import { fetchSubmitForm } from "../../modules/submit";
import { useRefresh } from "../common/useRedirect";
import { useNavigate } from "react-router-dom";

const txt = `인증하신 휴대폰 번호로\n케어코디 프로필을\n받아보실 수 있어요 ☺️`;

const PhoneNumber = () => {
  const [number, setNumber] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const form = useSelector((state) => state.form);
  const navigate = useNavigate();
  const { workType } = useSelector((state) => ({
    workType: state.form.workType,
  }));
  const dispatch = useDispatch();
  const handleSubmit = (form) => {
    dispatch(fetchSubmitForm(form)).then(() => navigate(`/finish`));
  };
  const handleChange = (e) => {
    setNumber(e.target.value);
    handleSetPhoneNumber(number);
    if (e.target.value.length === 11) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };

  const handleSetPhoneNumber = (phoneNumber) =>
    dispatch(setPhoneNumber(phoneNumber));
  return (
    <CommonContainer
      button={true}
      disabled={isDisabled}
      handleNextClick={() => handleSubmit(form)}
    >
      <Margin />
      <Title title={"신청완료"} description={txt} progressNum={4} />
      <HandlePhoneNumber />
      <CustomInput
        placeholder="전화번호를 입력해주세요 (숫자만 입력해주세요.)"
        value={number}
        onChange={handleChange}
        type="number"
      />
      {useRefresh(workType, navigate)}
    </CommonContainer>
  );
};

const Margin = styled.div`
  margin-top: 16px;
`;

const CustomInput = styled.input`
  width: 77vw;
  line-height: 2.5rem;
  font-family: "SpoqaHanSansNeoRegular";
  font-weight: 400;
  font-size: 14px;
  border: 1px solid #eeeeee;
  border-radius: 4px;
  padding-left: 16px;

  &:focus {
    outline: none;
  }

  ::placeholder {
    color: #b6b3b3;
    font-size: 13px;
  }
`;

export default PhoneNumber;
